import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromContact from '../../core/actions/contact.actions';
import * as fromContactR from '../../core/reducers/contact.reducer';
import { LazyLoadEvent } from 'primeng/api';
import { Pagination } from '../../shared/models/pagination';

@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {

  public contacts: any[];
  pagination: Pagination;
  lastPagination: string = '';

  constructor(
  	private store: Store<any>,

  ) { }

  ngOnInit() {  	
  	this.store.select(fromContactR.selectContacts).subscribe(contacts => this.contacts = contacts);
    this.store.select(fromContactR.selectContactPagination).subscribe(c => {console.log(c); this.pagination = c;});
  }
  loadLazy(event: LazyLoadEvent) {        
    if (JSON.stringify(event) !== this.lastPagination ) {
      this.store.dispatch(new fromContact.LoadContactsAction(event.sortField,event.sortOrder, event.filters, event.first, event.rows));
      console.log('load lazy', event);
      this.lastPagination = JSON.stringify(event);    
    }
    
    
  }  

  addContact() {
    this.store.dispatch(new fromContact.AddContactAction());
  }

 
}
